
    import { defineComponent, toRefs, ref, onMounted, watchEffect } from 'vue';
	import { toKebabCaseId } from '../services/core.utils';
	import { analyticsClickElmTrack } from '@/core/modules/analytics/services/analytics.click.track';

    export default defineComponent({
    props: {
        items: {
            type: Array,
            default() {
                return ['tab1', 'tab2', 'tab3'];
            }
        },
        itemActiveSet: {
            type: String,
            default: ''
        },
        modifier: {
            type: String,
            default: ''
        }
    },
    emits: ['tab-updated'],
    setup(props, { emit }) {
        const { items, itemActiveSet } = toRefs<any>(props);
        const itemActive = ref<string>('');

        function getKebabCaseId (value: string) {
            return toKebabCaseId(value);
        }

        function initTabs () {
            if (itemActive.value === '' || !itemActive.value) {
                setFirstItemActiveDefault();
            }

            if (itemActiveSet.value !== '') {
                itemActive.value = itemActiveSet.value;
            }
        }

        function setFirstItemActiveDefault () {
            itemActive.value = items.value[0];
        }

        function setItemActive (item: string): void {
            itemActive.value = item;
            emit('tab-updated', itemActive.value);

			analyticsClickElmTrack({
				name: 'tabs',
				id: itemActive.value
			});
        }

        watchEffect(initTabs);

        onMounted(initTabs);

        return { itemActive, setItemActive, getKebabCaseId }
    },
})
